import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private fire:AngularFirestore, private storage: AngularFireStorage) { }

  getMenus() {
    return this.fire.collection('menus').snapshotChanges()
  }
  
  addListToMenus(title:string,title_ar:string) {
    return new Promise((resolve, reject)=> {
      this.fire.collection("menus").add({
        title,
        title_ar
      }).then(()=>resolve())
    })
  }

  addItemtoMenu(
    id:string,
    title:string,
    title_ar:string,
    description:string,
    description_ar:string,
    price:number,
    photoUrl:File){
    return new Promise((resolve, reject)=>{      
      let ref = this.storage.ref('singlemenu/' + photoUrl.name)
      ref.put(photoUrl).then( ()=> {
      ref.getDownloadURL().subscribe(photoUrl => {
        this.fire.collection(`menus/${id}/singlemenu`).add({
          title,
          title_ar,
          description,
          description_ar,        
          price,
          photoUrl
        }).then(()=>resolve())
      })
    })
                
  }
)}

addPhotos(
  id1: string,
  id2:string,
  gPhoto: File,
) {
  return new Promise((resolve, reject) => {
    let ref = this.storage.ref('dishPhotos/' + gPhoto.name)
    ref.put(gPhoto).then(() => {
      ref.getDownloadURL().subscribe(gPhoto => {
        this.fire.collection(`menus/${id1}/singlemenu/${id2}/photos`).add({
          gPhoto,
        }).then(() => resolve())
      })
    })
  })
}

}
